"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusLight = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
var StatusLight = function (_a) {
    var children = _a.children, className = _a.className, full = _a.full, reverse = _a.reverse, split = _a.split, disabled = _a.disabled, pulsing = _a.pulsing, onClick = _a.onClick, onMouseOver = _a.onMouseOver, href = _a.href, _b = _a.color, color = _b === void 0 ? 'default' : _b, props = __rest(_a, ["children", "className", "full", "reverse", "split", "disabled", "pulsing", "onClick", "onMouseOver", "href", "color"]);
    var isCustomColor = function () {
        var uniqueColors = [
            'default',
            'info',
            'success',
            'warning',
            'critical',
        ];
        if (!uniqueColors.includes(color))
            return true;
        return false;
    };
    var colorClasses = function () {
        if (!disabled && !isCustomColor()) {
            return "StatusLight__indicator--" + color;
        }
        return false;
    };
    var StatusLightIndicatorClasses = classnames_1.default('StatusLight__indicator', colorClasses(), {
        'StatusLight__indicator--disabled': disabled,
    });
    var StatusLightClasses = classnames_1.default('StatusLight', className, {
        'StatusLight--disabled': disabled,
        'StatusLight--reverse': reverse,
        'StatusLight--full': full,
        'StatusLight--split': split,
        'StatusLight--pulsing': pulsing,
        'StatusLight--action': onClick || onMouseOver || href,
    });
    var StatusLightElement = href ? 'a' : 'div';
    return (react_1.default.createElement(StatusLightElement, __assign({ className: StatusLightClasses, href: href }, props),
        react_1.default.createElement("span", { className: StatusLightIndicatorClasses, style: isCustomColor() ? { backgroundColor: color } : null }),
        children !== undefined && children !== null && (react_1.default.createElement(__1.BodyText, { size: "small", className: "StatusLight__label" }, children))));
};
exports.StatusLight = StatusLight;
//# sourceMappingURL=StatusLight.js.map